<template>
  <v-bottom-sheet
    v-model="showCookie"
    scrollable
    @click:outside="close"
  >
    <v-card>
      <v-card-title>
        <h1 class="popup_title">
          Gestion des cookies
        </h1>
      </v-card-title>
      <v-card-text>
        <v-slide-y-transition hide-on-leave>
          <div v-show="!showMore">
            Lors de la consultation du site www.commande-aliments.agrial.com, des cookies sont déposés sur votre ordinateur, mobile, ou tablette. Un cookie est un petit fichier texte déposé sur votre ordinateur.
            Il a pour but de collecter des informations relatives à votre navigation sur l’application Commande Aliments. Le cas échéant, il permet de vous adresser des services personnalisés.
            En poursuivant votre navigation sur Commande Aliments, vous acceptez l’utilisation de cookies.
          </div>
        </v-slide-y-transition>
        <v-slide-y-reverse-transition hide-on-leave>
          <div v-show="showMore">
            <h3 class="text-h3">
              Informations
            </h3>
            <p class="text-justify">
              Lors de la consultation du site www.commande-aliments.agrial.com, des cookies sont déposés sur votre ordinateur, votre mobile ou votre tablette. Un cookie est un petit fichier texte déposé sur votre ordinateur lors de la visite du site. Ils ont notamment pour but de collecter des informations relatives à votre navigation sur l’application Commande Aliments et le cas échéant de vous adresser des services personnalisés.
            </p>
            <p class="text-justify">
              De manière générale, les "cookies" mémorisés via l’application Commande Aliments, ont l’une des fonctions suivantes :
              <ul>
                <li>
                  La première est de "maintenir l’état de l’application ", c’est-à-dire de faire en sorte que chaque fois que vous revenez sur le Site, vous visitiez l’application Commande Aliments dans la configuration que vous avez choisie.
                </li>
                <li>
                  La seconde fonction est de suivre de manière analytique le trajet de l’Utilisateur dans l’application Commande Aliments. Le "cookie" enregistre des données relatives à la navigation sur l’application Commande Aliments (les pages consultées, la date et l’heure de la consultation, le type de navigateur, etc.) ; cela permet de dresser des rapports statistiques de la fréquentation du Site. Avec ce "cookie", aucune donnée personnelle identifiable n’est enregistrée.
                </li>
              </ul>
            </p>

            <h3 class="text-h3">
              Le paramétrage de votre navigateur internet
            </h3>
            <p class="text-justify">
              Le fait de poursuivre la navigation sur l’application Commande Aliments vaut accord au dépôt de cookies ou autres traceurs sur son terminal.

              Vous pouvez être alerté quand vous recevez des "cookies", ou vous opposer à la mémorisation de "cookies" en configurant votre navigateur dans ce sens. Vous pouvez aussi supprimer les "cookies" déjà mémorisés. Si vous considérez que les "cookies" constituent une intrusion dans votre vie privée, configurez votre navigateur pour être alerté de la présence de "cookie" ou pour les refuser, et supprimez ceux déjà mémorisés.

              Voici comment contrôler et modifier vos souhaits en matière de cookies :

              La configuration de chaque navigateur est différente. Elle est décrite dans le menu d'aide de votre navigateur, qui vous permettra de savoir de quelle manière modifier vos souhaits en matière de cookies.
            </p>
            <p>
              À titre d'information voici les modalités pour les principaux navigateurs :
              <v-expansion-panels accordion>
                <v-expansion-panel>
                  <v-expansion-panel-header class="text-subtitle-2">
                    Google Chrome
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Dans le menu <b>Paramètres</b>, sélectionnez <b>"Afficher les paramètres avancés"</b> en bas de page.
                      </li>
                      <li>
                        Cliquez sur le bouton <b>"Paramètres de contenu"</b> dans la section Confidentialité
                      </li>
                      <li>
                        La section située en haut de la page qui apparaît alors vous en dit plus à propos des cookies et vous permet d'installer les cookies que vous voulez. Elle vous permet également de supprimer les cookies actuellement stockés.
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="text-subtitle-2">
                    Mozilla Firefox
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Dans le menu Outils, sélectionnez <b>"options"</b>
                      </li>
                      <li>
                        Sélectionnez l'onglet <b>Vie Privée</b> dans la fenêtre Options
                      </li>
                      <li>
                        Dans le menu déroulant, choisissez <b>"Utiliser les paramètres personnalisés pour l'historique"</b>. Cela fera apparaître les options pour les cookies et vous pourrez choisir de les autoriser ou de les refuser en cochant la case appropriée.
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="text-subtitle-2">
                    Safari
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Dans votre navigateur, choisissez le menu <b>Édition</b> > <b>Préférences</b>.
                      </li>
                      <li>
                        Cliquez sur <b>Sécurité</b>.
                      </li>
                      <li>
                        Cliquez sur <b>Afficher les cookies</b>.
                      </li>
                      <li>
                        Sélectionnez l'option que vous voulez dans la section "accepter les cookies".
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="text-subtitle-2">
                    Edge
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Dans le menu Outils, sélectionnez <b>"Paramètres"</b>
                      </li>
                      <li>
                        Cliquez sur "Afficher les <b>paramètres avancés</b>".
                      </li>
                      <li>
                        Sélectionnez l'option que vous voulez dans la section <b>"Cookies"</b>.
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="text-subtitle-2">
                    Samsung Browser
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Selectionnez le menu en haut à droit.
                      </li>
                      <li>
                        Cliquer sur <b>Paramètres</b>.
                      </li>
                      <li>
                        Choisir <b>Confidentialité et sécurité</b>
                      </li>
                      <li>
                        Cliquez sur <b>"Accepter les cookies"</b> pour activer ou désactiver. Ils sont acceptés si la case est coché.
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </p>
          </div>
        </v-slide-y-reverse-transition>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          rounded
          depressed
          @click="accept"
        >
          Accepter
        </v-btn>
        <v-btn
          rounded
          color="accent"
          outlined
          @click="showMore = !showMore"
        >
          {{ showMore ? 'Réduire': 'En savoir plus' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
export default {
  name: 'CookieConsent',
  data () {
    return {
      showCookie: true,
      showMore: false,
      cookieName: 'COOKIE_CONSENT',
      cookieDuration: '1y'
    };
  },
  created () {
    this.showCookie = !this.$cookies.get(this.cookieName);
  },
  methods: {
    accept () {
      this.$cookies.set(this.cookieName, 1, this.cookieDuration);
      this.showCookie = false;
    },
    close () {
      this.$cookies.set(this.cookieName, 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.popup_title{
  // white-space: pre-wrap;
  word-break: initial !important;
}
</style>
